import { COLORS } from '@styles/colors'
import styled from 'styled-components'

export const ListingInspection = styled.span`
  color: ${COLORS.primary};
`
